/* Reveal-on-scroll for .ss-reveal elements.
   Content is always visible without JS — this only drives the slide-up. */
(function () {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    document.querySelectorAll('.ss-reveal').forEach((el) => el.classList.add('in'));
    return;
  }
  const reveal = (el) => el.classList.add('in');
  const init = () => {
    const els = Array.from(document.querySelectorAll('.ss-reveal:not(.in)'));
    if (!els.length) return;
    if (!('IntersectionObserver' in window)) {
      els.forEach(reveal);
      return;
    }
    const io = new IntersectionObserver(
      (entries) => entries.forEach((e) => {
        if (e.isIntersecting) {
          reveal(e.target);
          io.unobserve(e.target);
        }
      }),
      { threshold: 0.06, rootMargin: '0px 0px -5% 0px' }
    );
    els.forEach((el) => {
      const r = el.getBoundingClientRect();
      if (r.top < window.innerHeight * 0.92 && r.bottom > 0) reveal(el);
      else io.observe(el);
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  // Theme editor re-renders sections in place
  document.addEventListener('shopify:section:load', init);
})();
